import { BaseMutations } from '@/store/base-mutations';
import GobalSearchState from './state';
import { GlobalSearch, SearchFilters } from '../types';

export default class GlobalSearchMutations extends BaseMutations<GobalSearchState> {
  SET_SEARCH_ITEMS(items: GlobalSearch.SearchItems[]) {
    this.state.search_items = items;
  }

  SET_SEARCH(value: string) {
    this.state.search = value;
  }

  SET_PAGES(pages: GlobalSearch.SearchPages[]) {
    this.state.available_search_pages = pages;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof SearchFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  TOGGLE_SEARCH_LOADING(value: boolean) {
    this.state.search_loading = value;
  }

  UPD_SELECTED_ITEM(value: string) {
    this.state.selected_item = value;
  }

  CLEAR_SEARCH() {
    this.state.search_items = [];
    this.state.available_search_pages = [];
    this.state.search = '';
  }
}
